import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  TemplateForCustomWrapper
} from './styled'

export class TemplateForCustom extends React.PureComponent {
  render () {
    const {
      className,
      ui,
      children,
      modifierName
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'template-base',
      {'is-modifier-name': modifierName},
      className
    )

    return (
      <React.Fragment>
        {(() => {
          switch (ui) {
            case 'XXXXX':
              return (
                <div>XXXXX</div>
              )
            default:
              return (
                <TemplateForCustomWrapper
                  className={classes}
                >
                  {children}
                </TemplateForCustomWrapper>
              )
          }
        })()}
      </React.Fragment>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
